import { RAMP_STEPS } from './map-scale';

/** The ramp, so a colour is never the only thing that carries a value. */
export function MapLegend({ noDataLabel, lowLabel, highLabel }: {
  noDataLabel: string;
  lowLabel: string;
  highLabel: string;
}) {
  return (
    <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-[11px] text-muted-foreground">
      <span className="inline-flex items-center gap-1.5">
        <span
          className="h-3 w-3 rounded-[4px] border border-border/60"
          style={{ background: 'hsl(var(--map-land))' }}
        />
        {noDataLabel}
      </span>

      <span className="inline-flex items-center gap-1.5">
        {lowLabel}
        <span className="inline-flex overflow-hidden rounded-[4px] border border-border/60">
          {Array.from({ length: RAMP_STEPS }, (_, index) => (
            <span
              key={index}
              className="h-3 w-5"
              style={{ background: `hsl(var(--map-step-${index + 1}))` }}
            />
          ))}
        </span>
        {highLabel}
      </span>
    </div>
  );
}
